import css from 'styled-jsx/css';
import { rgba } from '../../../../common/styling/theme';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';

  .ChooseProgramModalContent {
    display: flex;
    flex-direction: column;
    max-width: 577px;
    gap: 24px;
  }

  .ChooseProgramModalContent__description {
    margin-bottom: 0 !important;
    color: rgba(0, 0, 0, 0.5);
    font-size: 14px;
    line-height: 20px;
  }

  .ChooseProgramModalContent__criteria {
    padding: 24px;
    border-radius: 12px;
  }

  .ChooseProgramModalContent__criteriaLabel {
    margin-bottom: 16px;
    font-size: 20px;
    font-weight: 500;
  }

  .ChooseProgramModalContent__criteriaList {
    margin: 0;
    padding: 0;
    list-style: none;

    display: flex;
    flex-direction: column;
    gap: 18px;
  }

  .ChooseProgramModalContent__criteriaList li {
    display: flex;
    gap: 12px;
    align-items: center;

    font-size: 16px;
    line-height: 24px;
  }

  .ChooseProgramModalContent__action {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
  }

  .ChooseProgramModalContent__action-button .DefaultButton {
    width: 100%;
    min-height: 46px;
  }

  .Checkbox__label {
    color: rgba(0, 0, 0, 0.5);
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css.global`
    .ChooseProgramModalContent__criteria {
      background: ${rgba([colors.primary.rgb, 0.1])};
    }
  `;
};

export { staticStyles, getDynamicStyles };
